import { useWizard } from 'react-use-wizard'
import Input from '../../../components/Input'
import Button from '../../../components/Button'
import {
    REQUIRED_ERROR_MESSAGE,
    USERNAME_VALIDATION_ERROR_MESSAGE,
} from './constants'
import { USERNAME_REGEX } from '../../../utils'
import { useFormContext } from 'react-hook-form'
import {
    StepError,
    StepInput,
    StepInputContainer,
    StepTitle,
} from './step-elements'
import StepsNav from './StepsNav'
import { useEffect, useState } from 'react'
import { apiServiceInst } from '../../../services/Api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faSpinner } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2'

const UsernameStep = () => {
    const {
        register,
        trigger,
        watch,
        formState: { errors },
    } = useFormContext<{ username: string }>()
    const [loading, setLoading] = useState(false)
    const [available, setAvailable] = useState<null | boolean>(null)
    const [nextEnabled, setNextEnabled] = useState(true)

    const watchField = watch('username')

    const checkUsername = async (value: string): Promise<boolean> => {
        if (errors.username) {
            setNextEnabled(false)
            Swal.fire({
                toast: true,
                text: USERNAME_VALIDATION_ERROR_MESSAGE,
                position: 'bottom',
                showCloseButton: true,
                showConfirmButton: false,
            })
            return false
        }
        setLoading(true)
        const result = await apiServiceInst.checkUsernameAvailable(value)
        await new Promise((resolve) => setTimeout(resolve, 800))

        if (result === false) {
            setNextEnabled(false)
            Swal.fire({
                toast: true,
                text: 'Esiste già un account con questo username.',
                position: 'bottom',
                showCloseButton: true,
                showConfirmButton: false,
            })
        }
        setLoading(false)
        setAvailable(result)
        if (result) {
            await new Promise((resolve) => setTimeout(resolve, 500))
        }
        return result
    }
    useEffect(() => {
        trigger('username')
        setNextEnabled(true)
    }, [watchField])
    return (
        <div className="flex flex-col h-full">
            <StepTitle title="Scegli il tuo username" />
            <div className="grow">
                <StepInputContainer>
                    <StepInput
                        {...register('username', {
                            required: true,
                            pattern: {
                                value: USERNAME_REGEX,
                                message: USERNAME_VALIDATION_ERROR_MESSAGE,
                            },
                        })}
                        id="username"
                    />
                    {loading && <FontAwesomeIcon icon={faSpinner} spin />}
                    {available && (
                        <FontAwesomeIcon
                            icon={faCheck}
                            className="text-success"
                        />
                    )}
                </StepInputContainer>
                {/* <StepError fieldError={errors.username} /> */}
            </div>
            <StepsNav
                onNext={() => checkUsername(watchField)}
                nextEnabled={nextEnabled}
            />
        </div>
    )
}

export default UsernameStep
